<template>
  <div
    class="rounded-2xl p-3 md:px-4 md:pt-6 flex flex-col"
    :class="{
      'bg-white-005': !daoPageInfo.isCustom.value,
      [daoPageInfo.vueState.customClass === 'ape'
        ? 'bg-ape-main'
        : 'bg-aavegotchi-main']: daoPageInfo.isCustom.value,
    }"
    :style="`height: ${isDesktop ? 294 : 282}px`"
  >
    <div class="font-bold text-base md:text-xl">
      Comprehensive Data
      <tippy
        content="Comprehensive data refers to the ranking of daos among all daos in the dimensions of Socials, Community, Treasury, Governance, and Onchain Data"
        :arrow="false"
      >
        <i class="iconfont icon-tishi font-normal"></i>
      </tippy>
    </div>
    <div class="flex-1 min-h-0 mt-4">
      <!-- <div
        class="w-full h-full flex items-center justify-center"
        v-if="loading"
      >
        <Spin></Spin>
      </div> -->
      <div class="w-full h-full" ref="container">
        <VChart
          ref="chart"
          :key="width"
          :option="option"
          class="w-full h-full"
        ></VChart>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryOvMulDiGraph } from '@/api/dao';
import Spin from '@/components/Spin.vue';
import { useDesktop, useReqByBool } from '@/hooks';
import { useElementSize } from '@vueuse/core';
import { RadarChart } from 'echarts/charts';
import {
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { computed, inject, onMounted, reactive, ref } from 'vue';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  RadarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);
const chart = ref(null);
const container = ref(null);
const { width, height } = useElementSize(container);
const daoPageInfo = inject('daoPageInfo');
const isDesktop = useDesktop();
const state = reactive({
  data: [4200, 3000, 20000, 35000, 50000],
  max: 0,
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryOvMulDiGraph(daoPageInfo.vueState.info.id);

  console.log(res);

  const {
    discordPoint,
    onChainPoint,
    snapshotPoint,
    treasuryPoint,
    twitterPoint,
    maxDiscordPoint,
    maxOnChainPoint,
    maxSnapshotPoint,
    maxTreasuryPoint,
    maxTwitterPoint,
  } = res;
  state.data = [
    treasuryPoint,
    snapshotPoint,
    discordPoint,
    twitterPoint,
    onChainPoint,
  ];
  state.max = {
    maxDiscordPoint,
    maxOnChainPoint,
    maxSnapshotPoint,
    maxTreasuryPoint,
    maxTwitterPoint,
  };
});
const lineItem = {
  text: 'FT VAULT',
  color: daoPageInfo.isCustom.value
    ? daoPageInfo.vueState.customClass === 'ape'
      ? '#0623CBFF'
      : '#FA34F2FF'
    : '#FF5585FF',
  gradient: daoPageInfo.isCustom.value
    ? daoPageInfo.vueState.customClass === 'ape'
      ? '#0f184e'
      : '#FA34F240'
    : '#FF558540',
};

const option = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  tooltip: {
    borderColor: '#FFFFFF66',
    backgroundColor: '#1e1f21bb',
    textStyle: {
      color: '#fff',
    },
    formatter: (config) => {
      return `
      <div class="space-y-1">
        <div class="font-bold">Comprehensive data</div>
        <div>Treasury: ${state.max.maxTreasuryPoint - config.value[0] + 1}</div>
        <div>Governance: ${
          state.max.maxSnapshotPoint - config.value[1] + 1
        }</div>
        <div>Community: ${state.max.maxDiscordPoint - config.value[2] + 1}</div>
        <div>Socials: ${state.max.maxTwitterPoint - config.value[3] + 1}</div>
        <div>Holders: ${state.max.maxOnChainPoint - config.value[4] + 1}</div>
        </div>
      `;
    },
  },
  radar: {
    indicator: [
      { name: 'Treasury', max: state.max.maxTreasuryPoint },
      { name: 'Governance', max: state.max.maxSnapshotPoint },
      { name: 'Community', max: state.max.maxDiscordPoint },
      { name: 'Socials', max: state.max.maxTwitterPoint },
      { name: 'Holders', max: state.max.maxOnChainPoint },
    ],
    splitLine: {
      lineStyle: {
        color: '#2d2e30',
      },
    },
    splitArea: {
      areaStyle: {
        color: 'transparent',
      },
    },
    name: {
      textStyle: {
        color: '#FFFFFFB3',
      },
    },
    axisLine: {
      lineStyle: {
        color: 'transparent',
      },
    },
  },
  grid: {
    top: '4%',
    left: '10%',
    right: '4%',
    bottom: '4%',
    containLabel: true,
  },
  series: [
    {
      name: 'Comprehensive data',
      type: 'radar',
      color: lineItem.color,
      lineStyle: {
        color: lineItem.color,
      },
      areaStyle: {
        color: lineItem.gradient,
      },
      data: [
        {
          value: state.data,
        },
      ],
      symbolSize: 2,
    },
  ],
}));

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
